<div class="cart-item-list">
  @if (hasHeader) {
    <div class="d-none d-md-block d-lg-block d-xl-block">
      <div class="cx-item-list-header row">
        <div class="cx-item-list-desc col-md">
          {{ 'cartItems.description' | cxTranslate }}
        </div>
        <div class="cx-item-list-total col-md-auto">
          {{ 'cartItems.quantity' | cxTranslate }}
        </div>
      </div>
    </div>
  }

  @for (item of entries; track item; let i = $index) {
    <div class="cx-item-list-row">
      <div class="cx-item-list-items no-padding">
        <app-dispenser-order-items [customItem]="item" [readonly]="true"></app-dispenser-order-items>
      </div>
    </div>
  }
</div>
